import React, {FC} from "react";
import Typography from "@material-ui/core/Typography";
import {IPortfolio} from "../types/types";
import {Button, Card, CardActions, CardContent, Grid} from "@material-ui/core";
import { useHistory } from "react-router-dom";

interface IPortfolioProps {
    portfolio: IPortfolio
}



const Portfolio: FC<IPortfolioProps> = ({portfolio}: IPortfolioProps) => {
    let history = useHistory();

    const handleProjectClick = (id: number) => {
        history.push("/dams/"+id)

    }

    return (
        <Grid item xl={2} lg={3} sm={5} xs={11}>
            <Card>
                <CardContent>
                    <Typography color="textSecondary" gutterBottom>
                        Portfolio
                    </Typography>
                    <Typography variant="h5" component="h2">
                        {portfolio.name}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button  variant="outlined" size="small" onClick={prevState => handleProjectClick(portfolio.id || -1)}>Open</Button>
                </CardActions>
            </Card>
        </Grid>
    );
}

export default Portfolio;
